
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faChevronCircleDown } from '@fortawesome/free-solid-svg-icons'
import { defineComponent, ref, PropType } from 'vue'

type Menu = {
    title: string;
    content?: string;
}

export default defineComponent({
  name: 'Accordion',
  emits: ['change'],
  components: {
    FontAwesomeIcon
  },
  props: {
    menus: {
      type: Array as PropType<Menu[]>,
      required: true
    },
    openMenuIndex: {
      type: Number,
      required: false
    }
  },
  data () {
    return {
      activeIndex: ref(-1),
      tab: ref(null),
      chevron: faChevronCircleDown
    }
  },
  mounted () {
    this.activeIndex = 0
  },
  methods: {
    handleClick (index: number) {
      this.activeIndex = this.activeIndex === index ? -1 : index
      if (this.activeIndex >= 0) {
        this.$emit('change', this.menus[this.activeIndex])
      } else {
        this.$emit('change', null)
      }
    },
    handleToggle (index: number) {
      return this.activeIndex === index
        ? `max-height: ${(this.$refs.tab?.[index] as HTMLElement).scrollHeight}px`
        : ''
    }
  }
})

